import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all countries cities
export const fetchCountriesCities = createAsyncThunk(
  "countries_cities/fetchAll",
  async (page = 1, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/settings/countries-cities?page=${page}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);

const CountriesCitiesSlice = createSlice({
  name: "countries_cities",
  initialState: {
    countries_cities: [],
    isLoading: false,
    error: null,
    success: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountriesCities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCountriesCities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.countries_cities = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchCountriesCities.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      });
  },
});

export const { clearState } = CountriesCitiesSlice.actions;
export default CountriesCitiesSlice.reducer;
